var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckFilled24Px = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m4.766-12.357a1 1 0 1 0-1.532-1.286l-4.877 5.806-.078-.082-1.551-1.646a1 1 0 0 0-1.456 1.372l1.552 1.646.605.642.179.19.048.05.012.013.003.004h.001l.728-.685-.728.686a1 1 0 0 0 1.494-.043z",
  clipRule: "evenodd"
})));
export default SvgCheckFilled24Px;